var storage = {};

/**
 * Method gets value from memory
 * @param key
 */
export function get(key) {
    return storage[key];
}

/**
 * Method sets value in memory
 *
 * @param key
 * @param value
 * @param expire is ignored
 */
export function set(key, value) {
    storage[key] = value;

}

export function unset(key) {
    storage[key] = null;
}



/** WEBPACK FOOTER **
 ** ./legacy/home24/helpers/memory-storage.js
 **/